<template>
  <el-dialog
    :title="$t('zhuCe')"
    :visible.sync="visible"
    width="450px"
    :close-on-click-modal="false"
    @close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="0">
      <el-form-item :prop="website.roleType == 'gen' ? 'tenantId' : 'tenantIdext'">
        <el-select v-model="form[website.roleType == 'gen' ? 'tenantId' : 'tenantIdext']"
          style="width: 100%" :placeholder="$t('loginUserlogin.selectCountry')" @change="handleTenantChange">
          <el-option v-for="item in countryOptions" :key="item.tenantId"
            :label="item.tenantName" :value="item.tenantId" />
        </el-select>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input v-model="form.phone" :placeholder="$t('login.phone')" clearable>
          <i slot="prefix" class="icon-shouji" />
        </el-input>
      </el-form-item>
      <el-form-item prop="smsCode">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-input v-model="form.smsCode" :placeholder="$t('login.code')" clearable>
              <i slot="prefix" class="icon-yanzhengma" />
            </el-input>
          </el-col>
          <el-col :span="10">
            <el-button :disabled="codeDisabled" @click="getSmsCode" style="width: 100%">
              {{ codeText }}
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="form.password" type="password" :placeholder="$t('login.password')"
          :show-password="true">
          <i slot="prefix" class="icon-mima" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password2">
        <el-input v-model="form.password2" type="password" :placeholder="$t('qingQueRenMiMa')"
          :show-password="true" @keyup.enter.native="handleRegister">
          <i slot="prefix" class="icon-mima" />
        </el-input>
      </el-form-item>
      <el-form-item prop="locationAreaCode" v-if="website.roleType === 'shop'">
        <el-select v-model="form.locationAreaCode" style="width: 100%" placeholder="请选择店铺所在区域" clearable>
          <el-option v-for="item in areaOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item prop="areaId">
        <el-select v-model="form.areaId" style="width: 100%" placeholder="请选择代理区域"
          clearable @change="handleAreaChange">
          <el-option v-for="item in areaOptions" :key="item.value"
            :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item prop="generalId" v-if="website.roleType === 'shop'">
        <el-select v-model="form.generalId" style="width: 100%" :placeholder="$t('qingXuanZeZongDaiBianMa')"
          clearable @change="handleGeneralChange">
          <el-option v-for="item in generalOptions" :key="item.value"
            :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item prop="areaCodeId" v-if="website.roleType === 'shop'">
        <el-select v-model="form.areaCodeId" style="width: 100%" :placeholder="$t('xiaoShouJingLi')" clearable>
          <el-option v-for="item in areaCodeOptions" :key="item.value"
            :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" style="width: 100%" @click="showPrivacyDialog" :loading="loading">
          {{ $t('zhuCe') }} </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { genSmsCode } from "@/api/user";
import { getCuntList } from "@/api/general";
import { areaList, getGeneralCode, getAreaCode } from "@/api/archive";
import { isvalidatemobile } from "@/util/validate";

export default {
  name: "register",
  props: {
    value: Boolean
  },
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (!value) callback(new Error(this.$t('qingQueRenMiMa')));
      else if (value !== this.form.password) callback(new Error(this.$t('liangCiShuRuMiMaBuYiZhi')));
      else callback();
    };
    const validatePhone = (rule, value, callback) => {
      if (!value) callback(new Error(this.$t('login.phone')));
      else if (isvalidatemobile(value)[0]) callback(new Error(isvalidatemobile(value)[1]));
      else callback();
    };
    return {
      visible: this.value,
      loading: false,
      codeDisabled: false,
      codeText: this.$t('huoQuYanZhengMa'),
      codeTimer: null,
      form: {
        tenantId: '',
        tenantIdext: '',
        phone: '',
        smsCode: '',
        password: '',
        password2: '',
        areaId: '',
        generalId: '',
        areaCodeId: '',
        locationAreaCode: ''
      },
      validatePass2Fn: validatePass2,
      validatePhoneFn: validatePhone,
      countryOptions: [],
      areaOptions: [],
      generalOptions: [],
      areaCodeOptions: [],
      salesManagerOptions: []
    };
  },
  computed: {
    ...mapGetters(["website"]),
    rules() {
      return {
        tenantId: [{ required: true, message: this.$t('loginUserlogin.selectCountry'), trigger: 'change' }],
        tenantIdext: [{ required: true, message: this.$t('loginUserlogin.selectCountry'), trigger: 'change' }],
        phone: [{ validator: this.validatePhoneFn, trigger: 'blur' }],
        smsCode: [{ required: true, message: this.$t('login.code'), trigger: 'blur' }],
        password: [
          { required: true, message: this.$t('login.password'), trigger: 'blur' },
          { min: 6, message: this.$t('miMaChangDuZuiShao_6Wei'), trigger: 'blur' }
        ],
        password2: [{ validator: this.validatePass2Fn, trigger: 'blur' }],
        areaId: [{ required: true, message: this.$t('qingXuanZeSuoZaiQuYu'), trigger: 'change' }],
        generalId: [{ required: this.website.roleType === 'shop', message: this.$t('qingXuanZeZongDaiBianMa'), trigger: 'change' }],
        areaCodeId: [{ required: this.website.roleType === 'shop', message: '请选择销售经理', trigger: 'change' }],
        locationAreaCode: [{ required: false, message: '请选择店铺所在区域', trigger: 'change' }]
      };
    }
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        this.getCuntList();
        this.getProxyArea();
      }
    },
    visible(val) {
      this.$emit('input', val);
      if (!val && this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
    }
  },
  beforeDestroy() {
    if (this.codeTimer) clearInterval(this.codeTimer);
  },
  methods: {
    getCuntList() {
      getCuntList().then(res => {
        if (res.data.code == 200) this.countryOptions = res.data.data;
      });
    },
    getProxyArea() {
      areaList({type: '1'}).then(res => {
        if (res.data.success || res.data.code == 200) {
          const data = res.data.data || [];
          this.areaOptions = data.map(item => ({
            label: item.areaName || item.name || item.label,
            value: item.areaId || item.id || item.value,
            ...item
          }));
        }
      }).catch(() => {
        this.areaOptions = [];
      });
    },
    handleAreaChange(val) {
      if (!val) {
        this.form.generalId = '';
        this.form.areaCodeId = '';
        this.generalOptions = [];
        this.areaCodeOptions = [];
        return;
      }
      getGeneralCode(val).then(res => {
        if (res.data.success || res.data.code == 200) {
          const data = res.data.data || [];
          this.generalOptions = data.map(item => ({
            label: item.generalName || item.name || item.label || item.generalCode,
            value: item.generalId || item.id || item.value,
            ...item
          }));
        }
      }).catch(() => {
        this.generalOptions = [];
      });
      this.form.generalId = '';
      this.form.areaCodeId = '';
      this.areaCodeOptions = [];
    },
    handleGeneralChange(val) {
      if (!val) {
        this.form.areaCodeId = '';
        this.areaCodeOptions = [];
        return;
      }
      getAreaCode(val).then(res => {
        if (res.data.success || res.data.code == 200) {
          const data = res.data.data || [];
          this.areaCodeOptions = data.map(item => ({
            label: item.areaName || item.name || item.label || item.areaCode,
            value: item.areaId || item.id || item.value,
            ...item
          }));
        }
      }).catch(() => {
        this.areaCodeOptions = [];
      });
      this.form.areaCodeId = '';
    },
    handleTenantChange(val) {
      if (this.website.roleType != 'gen') {
        this.form.tenantId = '000000';
      }
    },
    getSmsCode() {
      if (!this.form.phone) {
        this.$message.warning(this.$t('login.phone'));
        return;
      }
      if (isvalidatemobile(this.form.phone)[0]) {
        this.$message.error(isvalidatemobile(this.form.phone)[1]);
        return;
      }
      const roleTypeMap = { factory: '1', gen: '2', shop: '4' };
      const params = {
        phone: this.form.phone,
        smsType: '1',
        roleType: roleTypeMap[this.website.roleType] || '2',
        tenantId: '100000', //this.website.roleType == 'gen' ? this.form.tenantId : this.form.tenantIdext
        appId: '01c6fcd31d11454f981ac1473a724d0c',
        appSecret: '91b3d375b421468f8a7eb43563c3de74'
      };
      genSmsCode(params).then(res => {
        if (res.data.success) {
          this.$message.success(this.$t('yanZhengMaYiFaSong'));
          this.startCountdown();
        } else {
          this.$message.error(res.data.msg || this.$t('faSongShiBai'));
        }
      }).catch(() => {
        this.$message.error(this.$t('faSongShiBai'));
      });
    },

    startCountdown() {

      let count = 60;
      this.codeDisabled = true;
      this.codeText = `${count}${this.$t('login.msgSuccess')}`;
      this.codeTimer = setInterval(() => {
        count--;
        if (count <= 0) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
          this.codeDisabled = false;
          this.codeText = this.$t('huoQuYanZhengMa');
        } else {
          this.codeText = `${count}${this.$t('login.msgSuccess')}`;
        }
      }, 1000);
    },
    showPrivacyDialog() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const roleTypeMap = { gen: '2', shop: '4' };
        const tenantId = this.website.roleType == 'gen' ? this.form.tenantId : this.form.tenantIdext;
        const selectedCountry = this.countryOptions.find(item => item.tenantId === tenantId);
        const selectedArea = this.areaOptions.find(item => item.value === this.form.areaId);
        const selectedGeneral = this.generalOptions.find(item => item.value === this.form.generalId);
        const selectedAreaCode = this.areaCodeOptions.find(item => item.value === this.form.areaCodeId);

        const formData = {
          appId: '01c6fcd31d11454f981ac1473a724d0c',
          appSecret: '91b3d375b421468f8a7eb43563c3de74',
          tenantId: tenantId || '',
          tenantIdext: this.website.roleType == 'gen' ? '' : (this.form.tenantIdext || ''),
          username: this.form.phone || '',
          phone: this.form.phone || '',
          password: this.form.password || '',
          newpassword: this.form.password2 || '',
          smsCode: this.form.smsCode || '',
          roleType: roleTypeMap[this.website.roleType] || '2',
          area: this.form.areaId || '',
          areaName: selectedArea ? (selectedArea.areaName || selectedArea.name || selectedArea.label || '') : '',
          generalCodePrefix: this.form.areaId || '',
          cunt: selectedCountry ? (selectedCountry.tenantName || selectedCountry.name || '') : '',
          areaCode: selectedAreaCode ? (selectedAreaCode.areaCode || selectedAreaCode.areaId || selectedAreaCode.id || selectedAreaCode.value || '') : '',
          areaCodeName: selectedAreaCode ? (selectedAreaCode.areaName || selectedAreaCode.name || selectedAreaCode.label || '') : '',
          generalCode: selectedGeneral ? (selectedGeneral.generalCode || selectedGeneral.generalId || selectedGeneral.id || selectedGeneral.value || '') : '',
          generalCodeName: selectedGeneral ? (selectedGeneral.generalName || selectedGeneral.name || selectedGeneral.label || '') : '',
          value: this.form.smsCode || '',
          locationAreaCode:this.form.locationAreaCode
        };
        if (this.website.roleType === 'shop') {
          formData.generalId = this.form.generalId || '';
          formData.areaCodeId = this.form.areaCodeId || '';
          formData.locationAreaCode = this.form.locationAreaCode || '';
        } else {
          formData.generalId = '';
          formData.areaCodeId = '';
          formData.locationAreaCode = '';
        }
        sessionStorage.setItem('registerFormData', JSON.stringify(formData));
        this.$router.push({ path: '/privacy/kvkk', query: { from: 'register' } });
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
      this.form.password2 = '';
      this.generalOptions = [];
      this.areaCodeOptions = [];
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
      this.codeDisabled = false;
      this.codeText = this.$t('huoQuYanZhengMa');
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
